import { render, staticRenderFns } from "./BriefDesc.vue?vue&type=template&id=5e5a9daf&scoped=true"
import script from "./BriefDesc.vue?vue&type=script&lang=js"
export * from "./BriefDesc.vue?vue&type=script&lang=js"
import style0 from "./BriefDesc.vue?vue&type=style&index=0&id=5e5a9daf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a9daf",
  null
  
)

export default component.exports